<script>
import transparenciaServico from '../../servico';
import Carregando from '~componentes/Carregando.vue';
import { datepicker } from 'vue-strap';
import CabecalhoRelatorio from './CabecalhoRelatorio.vue';

export default {
    name: 'RelatoriosProjeto',
    components: { CabecalhoRelatorio, Carregando, datepicker },
    data() {
        return {
            projeto: null,
            relatorio: null,
            arquivos: [],
            carregando: true,
            tituloRelatorio: 'Relatório de acompanhamento do projeto',
            RELATORIO_ACOMPANHAMENTO_PROJETO: '8',
            semResultado: false,
        }
    },
    methods: {
        async carregarProjeto(id) {
            return await transparenciaServico
              .informacaoProjeto(id)
              .then(informacaoProjeto => {
                  this.projeto = informacaoProjeto;
              });
        },
        async gerarRelatorioAcompanhamentoProjeto(id) {
            this.relatorio = null;
            try {
                const response = await transparenciaServico.relatorioAcompanhamentoProjeto(id);
                this.relatorio = response.find(obj => {
                    return obj.IDAcompanhamentoProjeto.toString() === this.$route.params.idAcompanhamentoProjeto.toString()
                });
            } catch (error) {
                throw error;
            }
        },
        carregarArquivos(idAcompanhamentoProjeto) {
            this.arquivos = [];
            return transparenciaServico
              .arquivosAcompanhamentoProjeto(idAcompanhamentoProjeto)
              .then(arquivos => {
                this.arquivos = arquivos;
              });
        },
        download(arquivo) {
          transparenciaServico
            .downloadAcompanhamentoProjeto(this.$route.params.idAcompanhamentoProjeto, this.nomeArquivo(arquivo))
            .then(arquivo => {
              arquivo.download();
            });
        },
        nomeArquivo(arquivo) {
          return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
        },
        verificaSemResultado() {
            if (this.arquivos.length === 0 || !this.relatorio || !this.projeto) {
                this.semResultado = true;
            }
        },
        voltar() {
            this.$router.push({
                name: 'transparencia.projetos.detalhar.lancamento',
                query: this.$route.query,
                params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_ACOMPANHAMENTO_PROJETO }
            });
        },
        async carregarDados() {
            this.carregando = true;
            this.semResultado = false;
            try {
                await Promise.all([
                    this.carregarProjeto(this.$route.params.id),
                    this.gerarRelatorioAcompanhamentoProjeto(this.$route.params.id),
                ]);
                this.carregarArquivos(this.$route.params.idAcompanhamentoProjeto);
                this.verificaSemResultado();
            } catch (error) {
                this.$swal('', 'Ocorreu um erro ao carregar os dados, tente novamente.', 'error');
                this.semResultado = true;
            } finally {
                this.carregando = false;
            }
        },
    },
    watch: {
        '$route': {
            immediate: true,
            async handler(to) {
                if (to.name === 'transparencia.projetos.detalhar-acompanhamento-projeto') {
                    await this.carregarDados();
                }
            }
        }
    },
    async created() {
        this.$root.tituloDaPagina = `Portal da transparência`;
        await this.carregarDados();
    },
}
</script>

<template>
    <div>
        <cabecalho-relatorio :titulo="tituloRelatorio" :nomeProjeto="projeto.nomeProjeto"
            borda=""></cabecalho-relatorio>

        <div class="row hidden-print" style="padding-left:20px">
            <div class="col-md-12 flex-container" style="justify-content:start; padding-left:15px">
                <h2><b>{{ tituloRelatorio }}</b></h2>
            </div>
        </div>

        <div class="row hidden-print" style="padding-left:20px">

            <div class="col-md-10 flex-container" style="justify-content:start; padding-left:15px">
                <h3><b>Projeto: {{ projeto.nomeProjeto }}</b></h3>
            </div>

            <div class="col-md-2 flex-container" style="justify-content:end; gap:10px">

                <button class="btn btn-primary" @click="voltar">
                    <i class="fa fa-arrow-left"></i> Voltar
                </button>

            </div>

        </div>

        <Carregando v-if="carregando" style="padding-top:20px"></Carregando>

        <div class="col-xs-12" v-if="carregando" style="padding-top:20px">
            <div class="ibox float-e-margins">
                <div class="ibox-content">
                    <p class="text-center">
                        Nenhum resultado encontrado.
                    </p>
                </div>
            </div>
        </div>

        <div v-if="!carregando" style="padding-top:20px">

            <div class="ibox float-e-margins">
                <div class="ibox-content">
                    <div class="table-responsive">

                        <table class="table relatorio table-bordered table-hover table-striped">
                            <thead>
                                <tr>
                                    <th>Numero do relatorio</th>
                                    <th>Início do período do relatório</th>
                                    <th>Final do período do relatório</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="relatorio">
                                    <td>{{ relatorio.NumeroRelatorio }}</td>
                                    <td>{{ relatorio.PeriodoRelatorioInicio | formatarData }}</td>
                                    <td>{{ relatorio.PeriodoRelatorioFim | formatarData }}</td>
                                </tr>
                                <tr v-if="!relatorio">
                                    <td colspan="3" class="text-center">Não há dados.</td>
                                </tr>
                            </tbody>
                        </table>

                        <table class="table relatorio table-bordered table-hover table-striped">
                            <thead>
                                <tr>
                                    <th>Documento</th>
                                    <th>Visualizar/Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="arquivo in arquivos">
                                  <td>{{ nomeArquivo(arquivo) }}</td>
                                  <td class="action">
                                      <button type="button"
                                              class="btn btn-default btn-xs"
                                              @click="download(arquivo)">
                                          <i class="fa fa-download"></i>
                                      </button>
                                  </td>
                                </tr>
                                <tr v-if="arquivos.length === 0 && !carregando">
                                    <td colspan="2" class="text-center">Nenhum arquivo encontrado.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/DetalharAcompanhamentoProjeto.vue